import { CardHeader } from "@/shared/ui/composites";
import { Divider, HStack, Icon, VStack } from "@/shared/ui/primitives";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

interface Log {
	timestamp: string;
	message: string;
	gyulAmount: number;
}

export interface LoggerCardProps {
	logs: Log[];
	isFetching?: boolean;
	onRefresh: () => void;
}

export const LoggerCard = (p: LoggerCardProps) => {
	const { t } = useTranslation();
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (scrollRef.current) {
			scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
		}
	}, [p.logs]);

	return (
		<VStack className="w-full px-[16px] py-[20px] rounded-[20px] gap-[20px] border border-outline bg-bg-weak/80 backdrop-blur-sm shadow-[0_8px_32px_rgba(15,23,42,0.06)]">
			<CardHeader
				title={t("workflow.loggerCardTitle")}
				description={t("workflow.loggerCardDescription")}
				buttonLabel={t("workflow.loggerCardButtonLabel")}
				onBtnTap={p.onRefresh}
				isLoading={p.isFetching}
			/>
			<Divider className="w-full" />
			<div ref={scrollRef} className="flex flex-col w-full max-h-[280px] gap-[10px] p-[12px] rounded-[12px] bg-bg-regular/60 overflow-auto justify-start">
				{p.logs.map((item, _) => (
					<HStack className="w-full gap-[10px] p-[4px] text-sm text-ct-regular">
						<span className="font-normal shrink-0">{item.timestamp}</span>
						<span className="w-full font-medium text-ct-strong">{item.message}</span>
						<HStack className="shrink-0">
							<Icon name="GyulLeft" width={16} height={16} />
							<span className="font-medium">
								{item.gyulAmount}
								{t("common.amount")}
							</span>
						</HStack>
					</HStack>
				))}
			</div>
		</VStack>
	);
};
